import { render, staticRenderFns } from "./ProductMatchProduct.vue?vue&type=template&id=9d171da6&scoped=true&"
import script from "./ProductMatchProduct.vue?vue&type=script&lang=js&"
export * from "./ProductMatchProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d171da6",
  null
  
)

export default component.exports